<ng-container *ngIf="active">
    <ng-container *ngTemplateOutlet="editTemplate">
    </ng-container>
</ng-container>
<ng-container *ngIf="!active">
    <ng-container *ngTemplateOutlet="viewTemplate">
    </ng-container>
</ng-container>
